export default __webpack_public_path__ + "static/2-5ee2994c0e357bc73ba7447fbb464773.png";